/**
 * @description Compose-UI From address for money-mail modals and Global Settings
 *
 * Key features:
 * - CP or CP→SO session: notifications@lynx.build (308 unverified factory)
 * - LynxPay-direct: notifications@lynxpay.us
 *
 * @dependencies none
 *
 * @notes Occupancy kind channel_partner or companies.channelPartnerId.
 *   Do not use this helper as the CP send path — server resolveChannelPartnerFromEmail
 *   is SoT. Display-only so the compose UI does not hardcode lynxpay.us.
 */

export const LYNX_GENERIC_FROM_EMAIL = 'notifications@lynx.build';
export const LYNXPAY_FROM_EMAIL = 'notifications@lynxpay.us';

/**
 * @param {{ occupancy?: { kind?: string }|null, company?: { channelPartnerId?: string|null, channel_partner_id?: string|null }|null }} [session]
 * @returns {string}
 */
export function resolveComposeFromEmail({ occupancy, company } = {}) {
  const isCpOrCpSo = occupancy?.kind === 'channel_partner'
    || Boolean(company?.channelPartnerId || company?.channel_partner_id);
  return isCpOrCpSo ? LYNX_GENERIC_FROM_EMAIL : LYNXPAY_FROM_EMAIL;
}
